import { RawAccountabilityPartner } from '@app/views/RawAccountabilityPartner';
import { ApiService } from '@stores/ApiService';
import { apiResponse } from '@stores/index';

export type AccountabilityPartnership = {
  id: number;
  participantId: number;
  partnerId: number;
};

export class AccountabilityPartnerStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async readByCohortId(groupId: number) {
    try {
      const response = await this.api.get(`AccountabilityPartner/cohort/${groupId}/`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async deletePartnersByCohort(groupId: number) {
    try {
      const response = await this.api.delete(`AccountabilityPartner/cohort/${groupId}/`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async deletePartnerRecordById(partnershipId: number) {
    try {
      const response = await this.api.delete(`AccountabilityPartner/${partnershipId}/`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async createPartner(partnership: RawAccountabilityPartner) {
    try {
      const response = await this.api.post(`AccountabilityPartner/`, partnership);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
